<template>
  <el-form :inline="true" class="demo-form-inline">


    <el-form-item label="支付日期">
      <el-date-picker v-model="model.date" type="datetimerange" single-panel />
    </el-form-item>



    <!--    <el-form-item label="支付时间">-->
    <!--      <el-date-picker v-model="model.date" type="date" placeholder="选择时间" clearable />-->
    <!--    </el-form-item>-->

    <el-form-item>
      <!-- 👇 点击触发父组件传入的 search 事件 -->
      <el-button type="primary" @click="$emit('search')">查询</el-button>
    </el-form-item>

  </el-form>
</template>

<script lang="ts" setup>
import {FormInline} from './tb_header_data'; // 引入类型
import {defineEmits, defineModel, defineProps} from 'vue';
import {Connection} from "@element-plus/icons-vue";
import {useRouter} from "vue-router"; // 引入类型

const model = defineModel<FormInline>('form-data');
// 👇 接收父组件传入的 formData
defineProps<{
  formData: FormInline;
}>();
// 定义触发的事件
defineEmits<{
  (e: 'search'): void
}>();

const changePage=()=>{
  window.open('https://starry.17xiudou.cn/h5/record/', '_blank');
}

const router = useRouter()

</script>
<style scoped>
.demo-form-inline .el-input {
  --el-input-width: 220px;
}

.demo-form-inline .el-select {
  --el-select-width: 220px;
}
</style>
